import React, { useState } from 'react';
import styled from 'styled-components';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqItems = [
    {
      question: "How much does it cost?",
      answer: "Axon is free to use during the beta. In the future, we will take 10% of payments processed through Axon. No setup fees, no monthly minimums."
    },
    {
      question: "Is Axon personalized to me?",
      answer: "Yes, like Instagram for coaching. Upload your content, customize your presence, and maintain your unique voice. We provide the tools to help you scale."
    },
    {
      question: "What does setup look like?",
      answer: "No contracts. Self-service setup that takes minutes, not days. Launch your coaching business at scale immediately."
    },
    {
      question: "Why is there an app and a website?",
      answer: "The app is for daily operations—creating programs, assigning workouts, and tracking client progress. The website handles initial setup, your AI twin configuration, and lead analytics."
    },
    {
      question: "How much time will I save?",
      answer: "Coaches using Axon report saving an average of 3 hours daily on routine client management while increasing their client capacity by 10x."
    }
  ];

  return (
    <SectionContainer>
      <SectionTitle>Common Questions</SectionTitle>
      <FaqContainer>
        {faqItems.map((item, index) => (
          <FaqItem key={index} active={activeIndex === index}>
            <QuestionRow onClick={() => toggleAccordion(index)}>
              <Question>{item.question}</Question>
              <ToggleIcon active={activeIndex === index}>
                {activeIndex === index ? '−' : '+'}
              </ToggleIcon>
            </QuestionRow>
            <Answer active={activeIndex === index}>
              {item.answer}
            </Answer>
            {index < faqItems.length - 1 && <Divider />}
          </FaqItem>
        ))}
      </FaqContainer>
    </SectionContainer>
  );
};

const SectionContainer = styled.section`
  padding: 8rem 6rem;
  background-color: #F5F5F7;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  @media (max-width: 768px) {
    padding: 6rem 2rem;
  }
`;

const SectionTitle = styled.h2`
  font-family: 'SF Pro Display', 'Satoshi', sans-serif;
  font-size: 48px;
  font-weight: 300;
  color: #1D1D1F;
  margin-bottom: 5rem;
  letter-spacing: -0.02em;
  text-align: center;
`;

const FaqContainer = styled.div`
  max-width: 800px;
  width: 100%;
`;

const FaqItem = styled.div`
  margin-bottom: ${props => props.active ? '2rem' : '1.5rem'};
`;

const QuestionRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 1rem 0;
`;

const Question = styled.h3`
  font-family: 'SF Pro Display', 'Satoshi', sans-serif;
  font-size: 20px;
  font-weight: 400;
  color: #1D1D1F;
`;

const ToggleIcon = styled.span`
  font-family: 'SF Pro Text', 'Plus Jakarta Sans', sans-serif;
  font-size: 24px;
  font-weight: 300;
  color: ${props => props.active ? '#BA865E' : '#1D1D1F'};
  transition: color 0.3s ease;
`;

const Answer = styled.div`
  font-family: 'SF Pro Text', 'Plus Jakarta Sans', sans-serif;
  font-size: 16px;
  line-height: 1.6;
  color: #86868b;
  max-height: ${props => props.active ? '200px' : '0'};
  opacity: ${props => props.active ? '1' : '0'};
  overflow: hidden;
  transition: all 0.3s ease;
  padding-bottom: ${props => props.active ? '1rem' : '0'};
`;

const Divider = styled.div`
  height: 1px;
  background-color: #DEDEDE;
  width: 100%;
`;

export default FAQ; 